export const ROUTES = {
  HOME: '/',
  CHECKOUT: '/checkout-payment/:paymentExternalId',
  PAYMENT: '/payment/:paymentExternalId',
  PAYMENT_STATUS: '/payment/:paymentExternalId/status',
  SUPPORT_PRO: '/astropay-pro/:usertag/support',
  GENERIC_ERROR: '/error',
};
